import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleApplyThreadFilters, setThreadShowMessages, setThreadShowCalls } from '../reducers/inboxReducer';
import { updateArrayById, areArraysEqualWhenSorted } from '../helpers/DataHelpers';
import { getCurrentOrg } from '../selectors/organizationSelectors';

const useThreadFilters = () => {
  const dispatch = useDispatch();
  const {
    threadFilteredChannelIds, // Default channel filter for inbox
    threadSelectedChannelIds, // Applied channel filter different than default
    threadActiveChannelIds, // Active channels available for filtering
  } = useSelector((state) => state.inbox);

  const currentOrg = useSelector(getCurrentOrg);
  const isVoipEnabled = !!currentOrg?.isVoipEnabled;

  const viewingChannelIds = threadSelectedChannelIds.length > 0
    ? threadSelectedChannelIds
    : threadFilteredChannelIds;

  const [selectedChannelIds, setSelectedChannelIds] = useState(viewingChannelIds);
  const showMessages = useSelector((state) => state.inbox.threadShowMessages);
  const showCalls = useSelector((state) => state.inbox.threadShowCalls);

  // Selected filter different than viewing filter
  const filtersEnabled = (selectedChannelIds.length > 0 &&
  !areArraysEqualWhenSorted(selectedChannelIds, viewingChannelIds)) ||
  !showMessages || !showCalls;

  // Selected filter different than default filter
  const filtersApplied = (selectedChannelIds.length > 0 &&
  !areArraysEqualWhenSorted(selectedChannelIds, threadFilteredChannelIds)) ||
  !showMessages || !showCalls;

  const handleApplyThreadFilterClick = () => {
    dispatch(handleApplyThreadFilters(selectedChannelIds));
  };

  const handleClearThreadFilterClick = () => {
    setSelectedChannelIds(threadFilteredChannelIds);
    dispatch(setThreadShowMessages(true));
    dispatch(setThreadShowCalls(true));
    dispatch(handleApplyThreadFilters(threadFilteredChannelIds));
  };

  const handleSelectChannelId = (id) => {
    setSelectedChannelIds(updateArrayById(selectedChannelIds, id));
  };

  const handleToggleMessages = () => dispatch(setThreadShowMessages(!showMessages));
  const handleToggleCalls = () => dispatch(setThreadShowCalls(!showCalls));

  return {
    filtersApplied,
    filtersEnabled,
    handleApplyThreadFilterClick,
    handleClearThreadFilterClick,
    handleSelectChannelId,
    handleToggleMessages,
    handleToggleCalls,
    isVoipEnabled,
    selectedChannelIds,
    showCalls,
    showMessages,
    threadActiveChannelIds,
    viewingChannelIds,
  };
};

export default useThreadFilters;
